import { brand } from '@alison/ui';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import type { MemberRow } from './types.js';

interface MemberRoleBadgeProps {
  role: MemberRow['role'];
}

export function MemberRoleBadge({ role }: MemberRoleBadgeProps): ReactNode {
  const isAdmin = role === 'admin';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        fontSize: 11,
        fontWeight: 700,
        py: 1,
        px: 2,
        borderRadius: 5,
        bgcolor: isAdmin ? 'info.bg' : 'border.default',
        color: isAdmin ? brand.purple : 'text.secondary',
      }}
    >
      {isAdmin ? (
        <>
          <VerifiedUserOutlinedIcon sx={{ fontSize: 13 }} />
          Admin
        </>
      ) : (
        'Member'
      )}
    </Box>
  );
}
